import React, { Component } from "react";

class HibuButton extends Component {
  render() {

    const { url, text, popUp } = this.props;

    if (!url) {
      return null;
    }

    const togglePopUp = (e) => {
      if (popUp) {
        e.preventDefault(e);
        window.open(url, text, "width=600,height=700");
      }
    }

    return (
      <div className="button">
        <a
          href={url}
          className="dmButtonLink dmWidget dmWwr default dmOnlyButton dmDefaultGradient"
          data-display-type="block"
          onClick={(e) => togglePopUp(e)}
        >
          <span className="text">{text}</span>
        </a>
      </div>
    );
  }
}

export default HibuButton;



// WEBPACK FOOTER //
// ./src/components/HibuButton.js